class ContentsNav {
  constructor(element) {
    this.btn = element;
    this.toc = document.querySelector('[data-js-child="toc"]');
    this.showContents = false;
    this.addEventListeners();
  }

  addEventListeners() {
    this.btn.addEventListener('click', (event) => this.onClick(event));
  }

  onClick(event) {
    event.preventDefault();
    this.showContents = !this.showContents;

    this.btn.classList.toggle('is-visible', this.showContents);
    this.toc.classList.toggle('is-visible', this.showContents);
    document.documentElement.classList.toggle('toc-open', this.showContents);
  }
}

const contentsBtn = document.querySelector('[data-js-module="toc-btn"]');
if (contentsBtn) {
  new ContentsNav(contentsBtn);
}

/**
 * https://css-tricks.com/how-to-animate-the-details-element/
 * with a little tweaking
 */
class Accordion {
  constructor(details) {
    this.details = details;
    this.summary = details.querySelector('summary');
    // content inside summary
    this.content = details.querySelector('.toc__list');
    this.children = [...this.details.querySelectorAll('.toc__details__item')];

    // Store the animation object (so we can cancel it if needed)
    this.animation = null;

    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));

    this.duration = 250;
    this.easing = 'ease-in-out';

    if (this.details.hasAttribute('open')) {
      for (let i = 0; i < this.children.length; i++) {
        this.children[i].classList.add('is-visible');
      }
    }
  }

  onClick(event) {
    event.preventDefault();
    this.details.style.overflow = 'hidden';

    // Check if the element is being closed or is already closed
    if (this.isClosing || !this.details.open) {
      this.open();
      // Check if the element is being openned or is already open
    } else if (this.isExpanding || this.details.open) {
      this.shrink();
    }

    this.animateChildren();
  }

  animateChildren() {
    for (let i = 0; i < this.children.length; i++) {
      setTimeout(() => {
        this.children[i].classList.toggle('is-visible');
      }, i * 25);
    }
  }

  shrink() {
    // Set the element as "being closed"
    this.isClosing = true;

    // Store the current height of the element
    const startHeight = `${this.details.offsetHeight}px`;
    // Calculate the height of the summary
    const endHeight = `${this.summary.offsetHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.details.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight],
    }, {
      duration: this.duration,
      easing: this.easing,
    });

    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(false);
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    // Apply a fixed height on the element
    this.details.style.height = `${this.details.offsetHeight}px`;
    // Force the [open] attribute on the details element
    this.details.open = true;
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    // Set the element as "being expanding"
    this.isExpanding = true;
    // Get the current fixed height of the element
    const startHeight = `${this.details.offsetHeight}px`;
    // Calculate the open height of the element (summary height + content height)
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.details.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight],
    }, {
      duration: this.duration,
      easing: this.easing,
    });

    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(true);
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    // Set the open attribute based on the parameter
    this.details.open = open;

    // Reset variables
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    // Reset styles
    this.details.style.height = this.details.style.overflow = '';
  }
}

const details = document.querySelectorAll('details');
if (details) {
  details.forEach((element) => {
    new Accordion(element);
  });
}

/**
 * Lazyload video poster image
 * @param {HTMLElement} video video target from IntersectionObserver
 */
const loadPosterImg = (video) => {
  if (video.dataset.poster) {
    const poster = video.dataset.poster;
    video.setAttribute('poster', poster);
  }
};

/**
 * Lazyload video sources
 * @param {HTMLElement} video video target from IntersectionObserver
 */
const loadVideoSrc = (video) => {
  video.src = video.dataset.src;

  // Trigger play
  video.load();
};

/**
 * Add class for animating lazyloaded video appearing
 * and remove intersection observer
 * @param {HTMLElement} video video target from IntersectionObserver
 */
const videoCleanup = (video) => {
  // Remove lazy class
  video.classList.add('is-loaded');

  // Remove Intersection observer
  lazyVideoObserver.unobserve(video);
};

const lazyVideoObserver = new IntersectionObserver((entries) => {
  entries.forEach((video) => {
    if (video.isIntersecting) {
      loadPosterImg(video.target);
      loadVideoSrc(video.target);
      videoCleanup(video.target);
    }
  });
});

const lazyloadInit = (container = document) => {
  const lazyVideos = container.querySelectorAll('video[loading="lazy"]');

  if (lazyVideos && lazyVideos.length > 0 && 'IntersectionObserver' in window) {
    lazyVideos.forEach((lazyVideo) => {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
};

lazyloadInit();


// Handles logo animations
import '@lottiefiles/lottie-player';

const animationBehavior = () => {
  window.animatingIn = true;
  const lottieEl = document.querySelector('lottie-player#logo');
  const lottieParent = lottieEl.closest('.branding');
  const maxFrameRate = 54;

  const lottiePlayer = lottieEl.getLottie();
  // start at final position
  lottieEl.seek(maxFrameRate);

  lottieParent.onmouseenter = () => {
    window.animatingIn = true;
    lottieEl.setDirection(-1);
    lottiePlayer.play();
  };

  lottieParent.onmouseleave = () => {
    window.animatingIn = false;

    if (Math.floor(lottiePlayer.currentFrame) === 0) {
      lottieEl.seek(0);
    }
    lottieEl.setDirection(1);
    lottiePlayer.play();
  };

  lottieParent.onmousedown = (event) => {
    event.preventDefault();
    lottiePlayer.pause();
  };

  lottiePlayer.addEventListener('complete', () => {
    lottiePlayer.stop();
  });

  lottieEl.addEventListener('frame', (event) => {
    const {detail} = event;
    if (Math.floor(detail.frame) === maxFrameRate && !window.animatingIn) {
      lottiePlayer.pause();
    }
  });
};

(function() {
  const player = document.querySelector('lottie-player#logo');
  player.addEventListener('rendered', animationBehavior);
}());

